import React from "react";
import ButtonFilledGreen from "../../UI/Buttons/ButtonFilledGreen/ButtonFilledGreen";
import Container from "../../UI/Container/Container"
import "./FeedbackForm.css"
import ReCAPTCHA from "react-google-recaptcha";
import { captcha_key } from "../../../config";
const FeedbackForm = (props) => {
    return (
        <div id="contactus" className="FeedbackForm__wrapper">
            <Container>
                <div className="FeedbackForm">
                    <h3 className="FeedbackForm__title">Contact us</h3>
                    <form onSubmit={props.formOnSubmit} className="FeedbackForm__form">
                        <input required className="FeedbackForm__input" placeholder="Your name*"                         value={props.nameValue} onChange={props.nameOnChange}/>
                        <input required className="FeedbackForm__input" type = "tel" placeholder="Your phone number*"  value={props.phoneValue} onChange={props.phoneOnChange}/>
                        <input required className="FeedbackForm__input" type="email" placeholder="Your email*"          value={props.emailValue} onChange={props.emailOnChange}/>
                        <textarea required className="FeedbackForm__input" placeholder="Leave a message*"       value={props.messageValue} onChange={props.messageOnChange}/>
                        {(props.nameValue && props.phoneValue && props.emailValue && props.messageValue)? 
                        <ReCAPTCHA
                            sitekey={captcha_key}
                            onChange={props.onChangeCaptcha}
                            ref={props.captchaRef}
                        />: null
                        }
                        <ButtonFilledGreen type="submit">Send</ButtonFilledGreen>
                    </form>
                </div>
            </Container>
        </div>
    )
}

export default FeedbackForm;